<div
  class="ui-card rounded-lg p-3 border border-gray-200 w-full flex items-center gap-3 cursor-pointer hover:bg-gray-50 hover:border-gray-300 transition-colors"
  [class.ui-card-emphasized]="variant() === 'emphasized'">
  @if (icon()) {
    <ui-icon class="flex-shrink-0 text-gray-400" [size]="24" [icon]="icon()!" />
  }

  <div class="flex-1 flex flex-col gap-1">
    @if (title()) {
      <strong class="title">{{ title() }}</strong>
    }

    @if (description()) {
      <span>{{ description() }}</span>
    }
  </div>

  @if (withChevronRight()) {
    <ui-icon icon="griddy-chevron-right" />
  }
</div>
